import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import Head from "@/components/Head/index.vue";
import { computed, defineComponent, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import UpLoadFile from "@/components/UpLoadFile/index.vue";
import DownFileList from "@/components/DownFileList/index.vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { changeInfoTotal } from "@/hooks/changeInfoTotal";
export default defineComponent({
  components: {
    Head: Head,
    UpLoadFile: UpLoadFile,
    DownFileList: DownFileList
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var query = useRoute().query;
    var router = useRouter();
    var type = query.type;
    console.log(type, "fd");
    var uploadRef = ref(null);
    var downFileList = ref(null); // type:0 推送给我的  1:私人的
    // state:0未上传  1已上传 
    // status: 0 :未推送 1 已推送 2待考核  3取消发布  4 进行中  5一结束  6 已过期 
    // 推送给我，未到开始时间    显示未到开始时间
    // 推送给我的  结束了，有附件,,私人的如果有附件就直接显示附件   显示附件列表
    // 推送给我的 结束了，没有附件,私人的如果没有附件就显示未上传附件    显示未上传附件
    // 推送给我的， 开会期间   显示 上传组件

    var statusFlag = computed(function () {
      return function (detail) {
        if (detail.status < 4 && type == "0") {
          return "weikaishi";
        }

        if (type == "0" && detail.status > 4 && detail.state == 0 || type == "1" && detail.state == 0) {
          return "wufujian";
        }

        if (type == "0" && detail.status > 4 && detail.state == 1 || type == "1" && detail.state == 1) {
          return "youfujian";
        }

        if (type == "0" && detail.status == 4) {
          return "shangchuan";
        }
      };
    });
    var files = [];

    function filechange(val) {
      files = val;
    } //回显


    var detail = reactive({
      title: '',
      recordId: '',
      startTime: "",
      finishTime: "",
      modifiedTime: "",
      content: "",
      information: ""
    });

    var getDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _uploadRef$value;

        var _yield$globalProperti, data, ids, fileList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["workselfDetail"]({
                  recordId: query.recordId
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                Object.assign(detail, data);
                ids = data.attachmentId ? data.attachmentId : "";
                downFileList.value && downFileList.value["showList"]({
                  type: "ids",
                  value: ids
                });

                if (!(ids != "" && detail['status'] != 5)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAttachment"]({
                  ids: ids
                });

              case 10:
                fileList = _context.sent;
                fileList.data.forEach(function (element) {
                  files.push({
                    name: element.realName,
                    id: element.attachmentId
                  });
                });

              case 12:
                (_uploadRef$value = uploadRef.value) === null || _uploadRef$value === void 0 ? void 0 : _uploadRef$value["editFile"](files);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDetail() {
        return _ref.apply(this, arguments);
      };
    }();

    getDetail(); //提交

    function submitForm() {
      return _submitForm.apply(this, arguments);
    } //按钮名称


    function _submitForm() {
      _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var attachmentId, _yield$globalProperti2, code;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                attachmentId = [];
                attachmentId = files.map(function (v) {
                  return v["id"];
                });
                _context2.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["workselfEdit"]({
                  recordId: query.recordId,
                  attachmentId: attachmentId.join(",")
                });

              case 4:
                _yield$globalProperti2 = _context2.sent;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  ElMessage.success("操作成功");
                  setTimeout(function () {
                    if (type == '0') {
                      changeInfoTotal(detail.recordId, "\u5DE5\u4F5C\u8BA1\u5212\u4E0E\u603B\u7ED3:".concat(detail.title), 21);
                    }

                    router.back();
                  }, 500);
                } else {
                  ElMessage.error("操作失败");
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _submitForm.apply(this, arguments);
    }

    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit;
    return {
      detail: detail,
      downFileList: downFileList,
      query: query,
      filechange: filechange,
      files: files,
      submitForm: submitForm,
      statusFlag: statusFlag,
      type: type,
      uploadRef: uploadRef,
      submitText: submitText
    };
  }
});